export const returns = {
  orderCancellation: {
    breadcrumb: {
      service: 'Beratung & Service',
      cancellation: 'Retoure & Bestellungen Widerrufen',
    },
    page: {
      title: 'Retoure oder Widerruf Ihrer Bestellung',
      introText1:
        'Sie können eine Retoure oder einen Widerruf für Ihre Bestellung über das untenstehende Formular veranlassen. Diese Option steht sowohl registrierten Kunden als auch Gastbestellern zur Verfügung.',
    },
    form: {
      orderNumber: 'Auftragsnummer',
      orderNumberError: 'Bitte geben Sie Ihre Auftragsnummer ein.',
      customerNumber: 'Kundennummer',
      submit: 'BESTELLUNG ANZEIGEN',
    },
    cancelOrder: {
      title: 'Artikel widerrufen oder retournieren',
      notFoundError: 'Die angegebene Auftrags- oder Kundennummer wurde nicht gefunden. Bitte überprüfen Sie Ihre Angaben.',
      introText2:
        'Wählen Sie die Artikel aus, die Sie widerrufen oder retournieren möchten, und bestätigen Sie Ihre Anfrage unten. Einige Artikel sind von der Retoure ausgeschlossen, wie konfigurierte oder maßgefertigte Produkte.',
      orderHeading: 'Bestellung {{orderNumber}}',
      orderDate: 'Bestelldatum:',
      selectAll: 'Alle auswählen',
      columnArticle: 'Artikel',
      columnQuantity: 'Menge',
      columnUnitPrice: 'Einzelpreis',
      columnTotalPrice: 'Preis',
      confirmationLabel:
        'Ich bestätige, dass ich die ausgewählten Artikel aus dieser Bestellung retournieren möchte',
      contactNameLabel: 'Name des Ansprechpartners',
      contactEmailLabel: 'E-Mail Adresse des Ansprechpartners',
      contactEmailError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      submitButton: 'Widerrufen oder Retournieren',
      submitHint:
        'Sobald Sie auf „Artikel widerrufen & Retournieren" klicken, senden wir Ihnen eine E-Mail zur Bestätigung, dass Ihre Anfrage eingegangen ist.',
      notCancellableTitle: 'Diese Bestellung ist vom Widerruf ausgeschlossen',
      notCancellableIntro:
        'Bestimmte Artikel, wie konfigurierte oder maßgefertigte Produkte, können nach Aufgabe der Bestellung nicht storniert werden. Bei Fragen melden Sie sich bitte beim Kundenservice.',
      notCancellableContactLink: 'Kundenservice kontaktieren',
      backToHome: 'Zurück zur Startseite',
    },
    productCard: {
      articleNumber: 'Artikelnummer: {{code}}',
      quantity: 'Menge',
      net: 'Netto',
      returnQuantityLabel: 'Menge',
      returnQuantityError: 'Es können nicht mehr Artikel wie bestellt widerrufen werden.',
      reasonLabel: 'Aus welchem Grund möchten Sie den Artikel retournieren? (optional)',
      descriptionLabel: 'Beschreibung:',
      reason: {
        damageBefore: 'Schaden vor Gebrauch',
        damageAfter: 'Schaden nach Gebrauch',
        wrongItem: 'Falscher Artikel geliefert',
        wrongQuantity: 'Falsche Menge geliefert',
        return: 'Rückgabe auf Kulanz',
      },
      notCancellableText: 'Dieser Artikel ist vom Widerruf ausgeschlossen, da er individuell angefertigt wurde.',
      notCancellableContactPrefix: 'Falls Sie Fragen zu dieser Restriktion haben, melden Sie sich bitte beim ',
      notCancellableContactLink: 'Kundenservice',
    },
    success: {
      title: 'Danke. Wir haben Ihre Anfrage erhalten.',
      backToHome: 'Zurück zu Startseite',
      returnSectionHeading: 'Artikel zurücksenden',
      returnSectionText:
        'Wenn Sie Ihre Artikel bereits erhalten haben, können Sie unten ein Rücksendeetikett herunterladen. Wir übernehmen damit die Rücksendekosten.',
      dhlButton: 'DHL Retouren-Etikett drucken',
      postButton: 'Post Retouren-Etikett drucken',
    },
  },
  breadcrumb: {
    service: 'Service & Vorteile',
    returns: 'Retoure',
  },
  returns: {
    page: {
      title: 'Retouren bei Wehrfritz',
      bannerAlt: 'Retouren bei Wehrfritz',
      noLabelHeading: 'Kein Retouren-Etikett zur Hand?',
      introText:
        'Sie möchten Ihre Sendung an uns zurückschicken? Am einfachsten geht das mit der Originalverpackung.',
      infoHeading: 'Aktuelle Information',
      infoDelay:
        'Derzeit verzögert sich das Auspacken der Retouren bei uns ein wenig. Deshalb dauern auch die Gutschriften und Rückbuchungen etwas länger.',
      infoThanks: 'Wir bitten Sie um Verständnis und danken für Ihre Geduld!',
      tipsHeading: 'Hinweise für Ihre Retoure',
      tips: {
        freeReturn:
          'Mit dem von uns bereitgestellten Retouren-Etikett ist die Rücksendung für Sie kostenlos.',
        exclusions:
          'Achtung! Folgende Produkte werden auftragsbezogen produziert und sind somit vom Umtausch ausgeschlossen: Möbel, Polster, Teppiche, Turngeräte, Außenspielgeräte.',
        validity:
          'Bitte beachten Sie: Das Retouren-Etikett ist nur für Rücksendungen an die HABA Sales GmbH & Co. KG in Bad Rodach gültig.',
        sizeWeight: 'Die maximale Paketgröße beträgt 60 x 60 x 120 cm, das Maximalgewicht 30 kg.',
        importantLabel: 'Wichtig:',
        importantDescription:
          'Bitte legen Sie Ihrer Retoure den Retourenschein mit ausgefüllten Retourengründen bei.',
        labelVisibility:
          'Kleben Sie das Retouren-Etikett gut sichtbar auf das Paket, bevor Sie es versenden.',
        receipt:
          'Bewahren Sie bitte den Einlieferungsbeleg auf. Er dient als Nachweis, falls das Paket unterwegs verloren geht.',
      },
      dropOffHeading: 'Eine Paketannahmestelle in Ihrer Nähe finden Sie',
      dropOffDhlPrefix: 'für DHL:',
      dropOffPostPrefix: 'für Post AT:',
      contactFormIntro: 'Wenn Sie nicht weiterkommen, nutzen Sie bitte folgendes Formular:',
      contactFormTitle: 'Kontaktformular',
    },
    form: {
      description:
        'Einfach hier ausdrucken. Geben Sie im nachfolgenden Eingabefeld einfach Ihre Auftragsnummer ein und klicken Sie auf Abschicken.',
      orderNumberLabel: 'Auftragsnummer',
      orderNumberPlaceholder: 'Auftragsnummer',
      submit: 'Absenden',
      submitAriaLabel: 'Retouren-Etikett Formular absenden',
      invalidOrder: 'Die angegebene Bestellnummer ist ungültig oder konnte nicht gefunden werden.',
      instructionsHeading: 'Retouren-Etikett selbst erstellen - so einfach geht es:',
      instructions: {
        selectCarrier: 'Wählen Sie Ihren Wunsch-Versender (DHL oder Hermes).',
        openOnlineForm: 'Es öffnet sich das Online-Retouren-Formular.',
        enterData: 'Tragen Sie Ihre Daten ein.',
        receiveLabel:
          'Sie erhalten Ihr Retouren-Etikett per E-Mail und können es direkt ausdrucken. Oder einfach den QR-Code auf Ihrem Smartphone speichern und im Paketshop vorzeigen.',
      },
      links: {
        dhl: 'DHL Retoure',
        hermes: 'Hermes Retoure',
        returnAT: 'RETOUREN-ETIKETT DRUCKEN',
      },
    },
  },
};
